module.exports = __webpack_public_path__ + "media/images/carosal-0800d79fd69d14d741858243749291de.jpg";